import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { initGa4 } from '@resida/analytics';
import App from './App';
import { routes } from './routes';
import { preloadForPath } from './content/guides';
import './index.css';
import './styles/landing.css';

initGa4(import.meta.env.VITE_GA4_MEASUREMENT_ID);

function Root() {
  return useRoutes(routes);
}

const root = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App>
        <Root />
      </App>
    </BrowserRouter>
  </React.StrictMode>
);

// Hydrate if pre-rendered content exists (production SSG build).
// In dev, the root contains only the placeholder comment, so we use createRoot.
const hasPreRenderedContent = root.firstElementChild !== null;

// A prerendered guide's body is a lazy chunk; load it first so hydration matches the HTML. If the
// chunk can't load (e.g. a deploy removed it), render anyway: the guide page shows its own error.
void preloadForPath(window.location.pathname)
  .catch(() => undefined)
  .then(() => {
    if (hasPreRenderedContent) {
      ReactDOM.hydrateRoot(root, app);
    } else {
      ReactDOM.createRoot(root).render(app);
    }
  });
